// Form lifecycle analytics. These ride the existing `/logevent/` path with the
// client-generated `sessionid` — no parallel analytics pipeline for this
// feature. Every call is fire-and-forget: analytics must never break a fill.
//
// Single-emitter rule (platform amendment 2026-07-31): each form event has
// exactly one producer. The widget emits only `FormStarted`, because tapping
// Start is a gesture no server-side write observes. Every write-anchored event —
// `FieldFilledViaChat`, `FormSubmitted`, `FormDiscarded`, `FormUpdated` — is
// emitted by Bot.API at the write. Emitting them here as well double-counted
// every chat fill and every discard.

import api, { EventTypes } from '../../API/api';

type EventContext = {
    indexName: string | null;
    sessionId: string;
    pageUrl?: string;
};

const emit = (eventtype: string, eventvalue: string | null, ctx: EventContext): void => {
    try {
        api.logEvent.logEvent({
            eventtype,
            eventvalue,
            indexname: ctx.indexName,
            sessionid: ctx.sessionId,
            pageurl: ctx.pageUrl || '',
        });
    } catch (_) {
        // Swallowed by design — see above.
    }
};

export const logFormStarted = (objectId: string, ctx: EventContext): void =>
    emit(EventTypes.FormStarted.toString(), objectId, ctx);
